import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";

const Video = () => {
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  const navigate = useNavigate();
  const { id, id2 } = useParams();
  const { contextData } = useContext(AuthContext);

  const downloadFile = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/video/${id2}/`,
        {}
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    const videoPlayer = document.getElementById("video-player");
    // const videoUrl = URL.createObjectURL(new Blob([responce.data]));
    if (videoPlayer) {
      videoPlayer.src = responce.data.file;
    }
  };

  useEffect(() => {
    userisinformation();
    downloadFile();
  }, []);

  const handelmarkasdone = async () => {
    let responce;
    try {
      responce = await axios.post(
        `https://pfebackend-zbz0.onrender.com/api/user/video/${id2}/`,
        null,

        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    navigate(`/formation/${id}`);
  };

  const userisinformation = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  return (
    <div className="video-bigcontainer">
      <div>
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}
      </div>

      <div className="video-display-container">
        <video id="video-player" className="videofile" controls></video>
      </div>
      <div className="markasdonbutton">
        <button className="btn-markasdone" onClick={handelmarkasdone}>
          Mark as Done
        </button>
      </div>
    </div>
  );
};

export default Video;
